import type { Review } from '../../types'

/** A person's name, never their identifier. Falls back to "Unknown reviewer". */
export function reviewerLabel(
  review: Pick<Review, 'reviewer_id' | 'reviewer_name' | 'reviewer_email'>,
  me: { id?: string; name?: string; email?: string } | null | undefined,
): string {
  const named = review.reviewer_name?.trim() || review.reviewer_email?.trim()
  if (named) return named
  if (me?.id && review.reviewer_id === me.id) return me.name?.trim() || me.email?.trim() || 'You'
  // An older review may carry the reviewer's email address as the id; that is a readable name.
  if (review.reviewer_id?.includes('@')) return review.reviewer_id
  return 'Unknown reviewer'
}
